import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import Drives from './Drives';
import Bandwidth from './Bandwidth';

export default class InventoryEdit extends React.Component {
  constructor(props) {
    super(props);
    props.updateDriveInventory(props.drives);
    props.updateBandwidth && props.updateBandwidth(props.bandwidth);

    this.updateDriveInventory = this.updateDriveInventory.bind(this);
  }

  updateDriveInventory(drive, index) {
    let { drives, updateDriveInventory } = this.props;
    let newDrives = update(drives, { $splice: [[index, 1, drive]] });
    updateDriveInventory(newDrives);
  }

  render() {
    let {
      drives,
      driveTypes,
      bandwidth,
      shouldHideDriveTitle,
      errors,
      updateBandwidth,
    } = this.props;
    return (
      <div>
        <Drives
          drives={drives}
          driveTypes={driveTypes}
          shouldHideDriveTitle={shouldHideDriveTitle}
          errors={errors && errors.drives}
          onChange={this.updateDriveInventory}
        />
        {bandwidth && (
          <Bandwidth
            bandwidth={bandwidth}
            errors={errors && errors.bandwidth}
            onChange={updateBandwidth}
          />
        )}
      </div>
    );
  }
}

InventoryEdit.propTypes = {
  actions: PropTypes.object.isRequired,
  driveTypes: PropTypes.array,
  drives: PropTypes.array,
  bandwidth: PropTypes.object,
  showErrors: PropTypes.bool,
  errors: PropTypes.any,
};
